import { DoctorRepository } from "@/domain/repository/doctor-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DeactivateDoctorUsecase {
  constructor(private readonly doctorRepo: DoctorRepository) {}

  async execute(doctorUuid: string): Promise<SATResult<void, SATError>> {
    return this.doctorRepo.deactivateDoctor(doctorUuid);
  }
}
